enum PaymentPurposeCode {
  ASC_REFUND_PORTION = 'ASC_REFUND_PORTION',
  FULL_CUSTOMER_REFUND = 'FULL_CUSTOMER_REFUND',
  DEALER_REIMBURSEMENT = 'DEALER_REIMBURSEMENT',
  DEALER_RESP_PORTION = 'DEALER_RESP_PORTION',
  LIENHOLDER_REFUND = 'LIENHOLDER_REFUND',
  ADMIN_FEE_REFUND = 'ADMIN_FEE_REFUND',
  PAID_TO_CUSTOMER_BY_DEALER = 'PAID_TO_CUSTOMER_BY_DEALER',
}

export default PaymentPurposeCode;
export type VerifyPaymentPurposeCode = Utils.VerifyExtends<
  Model.Enum.PaymentPurposeCode,
  Utils.ValueOf<typeof PaymentPurposeCode>
>;
